import React from 'react';
import type { ReceptionistDemoState } from '../../receptionist-dashboard/types';

export interface ReceptionistDashboardFooterProps {
  state: ReceptionistDemoState;
}

export function ReceptionistDashboardFooter({ state }: ReceptionistDashboardFooterProps) {
  const listening = state === 'empty';

  return (
    <footer className="mt-7 flex flex-wrap items-center gap-2.5 border-t border-[var(--cream-2)] px-1 py-4 text-[11.5px] text-[var(--ink-3)]">
      <span className="elva-live" />
      <span className="font-medium text-[var(--ink-2)]">{listening ? 'Listening' : 'On duty'}</span>
      <span className="font-[var(--font-mono)] text-[var(--ink-3)]">
        ·{' '}
        {listening
          ? 'ready for first call'
          : 'operating since 7:00 am · 47 conversations · 0 missed'}
      </span>
      <span className="ml-auto font-[var(--font-mono)]">
        <span className="text-[var(--ink-4)]">elva</span>
        <span className="text-[var(--ink-5)]"> · </span>
        <span className="text-[var(--ink-4)]">v2.4.1</span>
      </span>
    </footer>
  );
}
